// Full city-areas data + harbour/day-trips + seasons + map data

import { SPOTS, CLUSTERS } from "./planner";

const IMG = (id) =>
  `https://images.unsplash.com/photo-${id}?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400`;

const AREAS_SRC = [
  {
    id: "indre-by",
    name: "Indre By",
    tag: "The Old Town",
    color: "#FF4D00",
    coords: [55.6805, 12.58],
    blurb:
      "The medieval heart of the city, wrapped around the waterfront. Wander Strøget shopping mile and the Latin Quarter's charming streets — Strøget's high end sits near Kongens Nytorv, the Latin Quarter at the opposite end. Browse Torvehallerne, take a break in Kongens Have — then lose an afternoon or evening inside Tivoli Gardens, or a harbour beer along postcard-perfect Nyhavn.",
    shortBlurb:
      "The medieval heart of the city, wrapped around the waterfront. Wander Strøget shopping mile and the Latin Quarter's charming streets — Strøget's high end sits near Kongens Nytorv, the Latin Quarter at the opposite end.",
    highlights: ["Nyhavn", "Tivoli", "Amalienborg", "Strøget", "Kongens Have", "Marmorkirken"],
    picks: [
      { name: "Nyhavn", note: "The candy-coloured canal everyone photographs — worth the cliché.", coords: [55.6799, 12.5913] },
      { name: "Tivoli Gardens", note: "The 1843 pleasure garden — pure magic after dark.", coords: [55.6737, 12.5681] },
      { name: "Amalienborg", note: "The royal palace — watch the noon changing of the guard.", coords: [55.6841, 12.5934] },
      { name: "Marmorkirken", note: "The domed Marble Church, right by Amalienborg.", coords: [55.685, 12.5894] },
    ],
    mapExtras: [
      { name: "Latinerkvarteret", coords: [55.67831, 12.56966] },
      { name: "Rosenborg Castle", coords: [55.6857, 12.5772] },
      { name: "Kongens Have", coords: [55.6857, 12.58] },
      { name: "Magstræde", coords: [55.67638, 12.57549] },
      { name: "Rundetårn", coords: [55.6813, 12.5757] },
      { name: "Strøget", coords: [55.6786, 12.576] },
      { name: "La Glace", coords: [55.6786, 12.5735] },
      { name: "Torvehallerne", coords: [55.6838, 12.5695] },
      { name: "Sankt Peders Bageri", coords: [55.67913, 12.56921] },
      { name: "The Little Mermaid", coords: [55.6929, 12.5993] },
    ],
    image: "https://customer-assets-cm19k8pv.emergentagent.net/job_explore-copenhagen/artifacts/9eyx3e0p_2026-08-17%2000_00_57.118%2B0200.webp",
  },
  {
    id: "christianshavn",
    name: "Christianshavn",
    tag: "Canals & Christiania",
    color: "#005DE8",
    coords: [55.672, 12.592],
    blurb:
      "Charming canal, houseboats and café-lined quays — plus Freetown Christiania, the car-free, self-governed enclave that has played by its own rules since 1971.",
    highlights: ["The canal", "Freetown Christiania"],
    picks: [
      { name: "Freetown Christiania", note: "A car-free, self-governed world since 1971.", coords: [55.6761, 12.599] },
      { name: "The Canal", note: "Charming waterways and houseboats.", coords: [55.67243, 12.59083] },
      { name: "Our Saviour's Church", note: "Climb the corkscrew spire for the best view.", coords: [55.67291, 12.59425] },
      { name: "Amagergade", note: "Old street vibe with colourful yellow houses.", coords: [55.6708, 12.5929] },
    ],
    image: "https://customer-assets-cm19k8pv.emergentagent.net/job_explore-copenhagen/artifacts/vqlv1nqi_20260805_170613.webp",
  },
  {
    id: "islands-brygge",
    name: "Islands Brygge",
    tag: "Harbour living",
    color: "#005DE8",
    coords: [55.6685, 12.5798],
    blurb:
      "The waterfront promenade where the whole city comes to swim. The famous Harbour Bath (Havnebadet), the newer Havnevigen beach, and Nokken — a ramshackle village of allotment gardens right on the water.",
    highlights: ["Bryggen promenade", "Havnevigen", "Nokken"],
    picks: [
      { name: "Havnebadet", note: "The original harbour bath — dive into the city." },
      { name: "Andersen Bakery", note: "Cakes & pastries on the promenade.", coords: [55.667138, 12.578329] },
      { name: "Havnevigen", note: "A newer sandy beach right on the harbour.", coords: [55.6545, 12.5656] },
      { name: "Nokken", note: "A hidden village of allotment gardens on the water.", coords: [55.6517, 12.5628] },
    ],
    image: "https://customer-assets-cm19k8pv.emergentagent.net/job_explore-copenhagen/artifacts/0f3tr0l7_2026-08-16%2023_45_31.721%2B0200.webp",
  },
  {
    id: "refshaleoen",
    name: "Refshaleøen",
    tag: "Post-industrial playground",
    color: "#FFD700",
    coords: [55.69, 12.611],
    blurb:
      "A shipyard reborn as the city's most exciting hangout — Reffen's 50+ street-food stalls, the tiny wine-and-swim shack La Banchina, and CopenHill: a real ski slope built on top of a power plant.",
    highlights: ["Reffen street food", "La Banchina", "CopenHill", "Operaen", "Opera Park"],
    picks: [
      { name: "Reffen street food", note: "50+ street-food stalls on the waterfront.", coords: [55.6931, 12.6097] },
      { name: "La Banchina", note: "A tiny wine bar with a swim ladder and sauna.", coords: [55.6906, 12.6079] },
      { name: "CopenHill", link: "https://gyg.me/gbJD4cCp", note: "Ski, hike or climb a power plant's green roof.", coords: [55.6844, 12.62] },
      { name: "Operaen & Opera Park", note: "The striking waterfront Opera House, now wrapped by the lush new Opera Park (2024).", coords: [55.6808, 12.6003] },
    ],
    image: "https://customer-assets-cm19k8pv.emergentagent.net/job_explore-copenhagen/artifacts/jgzvbpg6_2026-08-17%2000_05_23.278%2B0200.webp",
  },
  {
    id: "vesterbro",
    name: "Vesterbro",
    tag: "Grit & good coffee",
    color: "#FFD700",
    coords: [55.6667, 12.55],
    blurb:
      "Once the red-light district, now the city's coolest hangout. Istedgade's bars, the Meatpacking District (Kødbyen) packed with cafés, restaurants and late-night dancing, and laid-back Enghave. This is where locals actually spend their weekends.",
    highlights: ["Istedgade", "Kødbyen (Meatpacking)", "Enghave plads", "Ismageriet (Kødbyen)"],
    picks: [
      { name: "Kødbyen", note: "The Meatpacking District — cafés, galleries and late nights." },
      { name: "Istedgade", note: "Formerly seedy, now the city's liveliest bar strip.", coords: [55.66907, 12.55334] },
      { name: "Enghave Plads", note: "Leafy square ringed with neighbourhood coffee spots.", coords: [55.6671, 12.5452] },
      { name: "Værnedamsvej", note: "The charming 'little Paris' food street on the Vesterbro–Frederiksberg border — wine bars, delis, florists and cafés.", coords: [55.6736, 12.5499] },
    ],
    image: IMG("1764756719784-7e46c361e0ba"),
  },
  {
    id: "norrebro",
    name: "Nørrebro",
    tag: "Multicultural cool",
    color: "#FF4D00",
    coords: [55.6897, 12.556],
    blurb:
      "The most diverse and creative district. Shop tiny Jægersborggade, cross the crowded Dronning Louises Bro, hang on Sankt Hans Torv and Blågårdsgade, and pay respects at Assistens Kirkegård — where H.C. Andersen is buried.",
    highlights: ["Nørrebrogade", "Jægersborggade", "Assistens Kirkegård", "Blågårdsgade", "Sankt Hans Torv", "Dronning Louises Bro"],
    picks: [
      { name: "Assistens Kirkegård", note: "A park-cemetery where H.C. Andersen is buried.", coords: [55.6911, 12.5494] },
      { name: "Den Sorte Plads", note: "Superkilen's black square — the neighbourhood's outdoor living room.", coords: [55.6989, 12.5422] },
      { name: "Jægersborggade", note: "A single street of tiny makers, bakeries and wine bars.", coords: [55.6927, 12.5439] },
      { name: "Dronning Louises Bro", note: "The bridge where all of Nørrebro sunbathes.", coords: [55.687, 12.566] },
    ],
    image: "https://customer-assets-cm19k8pv.emergentagent.net/job_explore-copenhagen/artifacts/o02lxa24_2026-08-16%2023_47_08.018%2B0200.webp",
  },
  {
    id: "osterbro",
    name: "Østerbro",
    tag: "Leafy & local",
    color: "#005DE8",
    coords: [55.705, 12.576],
    blurb:
      "Copenhagen's genteel side. Cheer for F.C. Copenhagen at Parken stadium, browse Nordre Frihavnsgade's shops, peek into the historic Brumleby workers' cottages and do a picnic in vast Fælledparken.",
    highlights: ["Parken", "Fælledparken", "Nordre Frihavnsgade", "Brumleby"],
    picks: [
      { name: "Parken", note: "Home of F.C. Copenhagen; matchdays are electric.", coords: [55.7028, 12.572] },
      { name: "Nordre Frihavnsgade", note: "Østerbro's shopping street — boutiques, cafés and delis.", coords: [55.70343, 12.58792] },
      { name: "Brumleby", note: "Rows of pastel 1850s workers' cottages, frozen in time.", coords: [55.7015, 12.5756] },
    ],
    mapExtras: [
      { name: "Fælledparken", coords: [55.701, 12.568] },
      { name: "Tårnlegepladsen (Tower Playground)", coords: [55.69722, 12.56966] },
      { name: "Classens Have", coords: [55.69785, 12.58882] },
    ],
    image: IMG("1764757208278-ad166341497a"),
  },
  {
    id: "amager",
    name: "Amager",
    tag: "Beach & island air",
    color: "#FFD700",
    coords: [55.66, 12.6],
    blurb:
      "The big island south of the centre. Shop the giant Fields mall, stroll Ørestad's bold new architecture, swim at Amager Strandpark, and wander cobbled, hollyhock-lined Dragør.",
    highlights: ["Fields", "8TALLET", "Dragør", "Ørestad", "Amager Strandpark", "Kalvebod Fælled"],
    picks: [
      { name: "Amager Strandpark", note: "A 4.6km artificial beach 15 min from the centre.", coords: [55.66298, 12.63851] },
      { name: "Dragør", note: "A cobbled fishing village of yellow cottages.", coords: [55.593, 12.673] },
      { name: "Ørestad", note: "An architecture stroll among the bold new builds — 8TALLET, the VM Houses and the Mountain.", coords: [55.6286, 12.576] },
    ],
    mapExtras: [
      { name: "8TALLET", coords: [55.6175, 12.5718] },
      { name: "Kalvebod Fælled", coords: [55.6, 12.556] },
    ],
    image: IMG("1631623309554-a9e7133b9be0"),
  },
  {
    id: "frederiksberg",
    name: "Frederiksberg",
    tag: "Grand & green",
    color: "#FF4D00",
    coords: [55.678, 12.533],
    blurb:
      "A stately city-within-the-city. Stroll the romantic Frederiksberg Gardens, spot elephants and the famous tower at the Zoo, and duck into Frederiksberg Centret when the weather turns.",
    highlights: ["Copenhagen Zoo", "Frederiksberg Have", "Frederiksberg Centret"],
    picks: [
      { name: "Frederiksberg Have", note: "Romantic gardens with canals and a hilltop palace.", coords: [55.675, 12.524] },
      { name: "Copenhagen Zoo", link: "https://gyg.me/W3Senqr2", note: "Spot the elephants from the free garden path.", coords: [55.6725, 12.523] },
      { name: "Frederiksberg Allé", note: "A grand tree-lined boulevard of theatres.", coords: [55.67389, 12.54167] },
      { name: "Værnedamsvej", note: "The charming 'little Paris' food street on the Vesterbro–Frederiksberg border — wine bars, delis, florists and cafés.", coords: [55.6736, 12.5499] },
    ],
    mapExtras: [{ name: "Landbohøjskolens Have", coords: [55.68004, 12.54177] }],
    image: "https://customer-assets-cm19k8pv.emergentagent.net/job_explore-copenhagen/artifacts/dp5191x1_2026-08-16%2023_51_25.850%2B0200.webp",
  },
  {
    id: "nordvest",
    name: "Nordvest",
    tag: "Rough-edged & real",
    color: "#FFD700",
    coords: [55.705, 12.54],
    blurb:
      "Untouristed and proud of it. Gritty streets, old brown-bar bodegaer where a beer still costs next to nothing, and the breathtaking Grundtvig's Church — an expressionist cathedral built from six million yellow bricks.",
    highlights: ["Grundtvigs Kirke", "Bispebjerg Cemetery"],
    picks: [
      { name: "Grundtvigs Kirke", note: "An expressionist cathedral of six million bricks.", coords: [55.71661, 12.53382] },
      { name: "Bispebjerg Cemetery", note: "Terraced 'cherry-blossom' avenues at Bispebjerg Kirkegård — magical in spring.", coords: [55.71259, 12.52271] },
      { name: "Rentemestervej", note: "A cultural pocket of Nordvest around the striking library — galleries, cafés and everyday local life.", coords: [55.7049, 12.5349] },
    ],
    image: "https://customer-assets-cm19k8pv.emergentagent.net/job_explore-copenhagen/artifacts/n2qwkzm4_20260417_124423.webp",
  },
  {
    id: "nordhavn",
    name: "Nordhavn",
    tag: "New architecture & sea air",
    color: "#FF4D00",
    coords: [55.71, 12.59],
    blurb:
      "The former container port turned sleek new district. Bold contemporary architecture, a stunning harbour bath, and quiet waterside cafés with serious design credentials — the future of the city.",
    highlights: ["The harbour bath", "Konditaget Lüders", "New architecture"],
    picks: [
      { name: "Sandkaj Harbour Bath", note: "The sleek Nordhavn quay where locals dive straight off the deck.", coords: [55.7063, 12.5943] },
      { name: "Konditaget Lüders", note: "A rooftop playground and gym atop a car park — sweeping views over Nordhavn and the water.", coords: [55.7077, 12.5980] },
      { name: "Waterside cafés", note: "Design-forward spots with sea views.", coords: [55.7072, 12.5948] },
    ],
    image: IMG("1595330449922-cb8256e9e678"),
  },
  {
    id: "carlsberg-byen",
    name: "Carlsberg Byen",
    tag: "Beer heritage, reborn",
    color: "#FF4D00",
    coords: [55.665, 12.53],
    blurb:
      "The old Carlsberg brewery grounds, now a buzzing new quarter. Walk beneath the famous Elephant Gate, tour the Home of Carlsberg museum, and café-hop between the historic red-brick halls and shiny new towers — lunch at Wulff & Konstali, Dolores or Aamanns Genbo around Kildepladsen.",
    highlights: ["New architecture", "Elephant Gate", "Home of Carlsberg museum"],
    picks: [
      { name: "Elephant Gate", note: "The iconic granite elephants guarding the old brewery.", coords: [55.6673, 12.5323] },
      { name: "Home of Carlsberg", link: "https://gyg.me/wg6bmKQ1", note: "Beer history, horses and a tasting bar.", coords: [55.6673, 12.5351] },
      { name: "Humlebyen", link: "https://maps.app.goo.gl/MeoAtfk4byA1mV9f9", note: "The charming cluster of colourful little terraced houses built for Carlsberg brewery workers — quiet, photogenic lanes just beside the brewery.", coords: [55.6679, 12.5368] },
      { name: "Aire Ancient Baths", link: "https://maps.app.goo.gl/tJQfX31jMf2yPmbw7", note: "Candle-lit thermal baths set inside a former Carlsberg bottling hall on Ny Carlsberg Vej — a serene spa escape.", coords: [55.6671, 12.5333] },
    ],
    mapExtras: [
      { name: "J.C. Jacobsens Have", coords: [55.6644, 12.5332] },
      { name: "Københavns Bageri", coords: [55.6648, 12.5355] },
    ],
    image: IMG("1641837225691-448e2a2907e1"),
  },
];

// Display order for the Areas page + prev/next navigation
const AREA_DISPLAY_ORDER = [
  "indre-by",
  "christianshavn",
  "islands-brygge",
  "refshaleoen",
  "vesterbro",
  "norrebro",
  "osterbro",
  "nordhavn",
  "nordvest",
  "carlsberg-byen",
  "frederiksberg",
  "amager",
];

export const AREAS = AREA_DISPLAY_ORDER
  .map((id) => AREAS_SRC.find((a) => a.id === id))
  .filter(Boolean);

export const getArea = (id) => AREAS.find((a) => a.id === id);

// Home page shows only the two biggest
export const FEATURED_AREAS = [
  AREAS.find((a) => a.id === "indre-by"),
  AREAS.find((a) => a.id === "christianshavn"),
];

// Must-see sights for the interactive map
export const SIGHTS = [
  { name: "Tivoli Gardens", coords: [55.6737, 12.5681] },
  { name: "Nyhavn", coords: [55.6799, 12.5913] },
  { name: "The Little Mermaid", coords: [55.6929, 12.5993] },
  { name: "Rosenborg Castle", coords: [55.6857, 12.5772] },
  { name: "Rundetårn", coords: [55.6813, 12.5757] },
  { name: "Freetown Christiania", coords: [55.6761, 12.599] },
  { name: "CopenHill", coords: [55.6844, 12.62] },
  { name: "Christiansborg", coords: [55.6759, 12.5797] },
  { name: "Torvehallerne", coords: [55.6838, 12.5695] },
  { name: "Grundtvigs Kirke", coords: [55.71661, 12.53382] },
];

export const HARBOUR_BATHS = [
  {
    name: "Islands Brygge Havnebad",
    meta: "Islands Brygge",
    desc: "The original and iconic — right on the harbour promenade, packed all summer.",
    image: "https://customer-assets-cm19k8pv.emergentagent.net/job_explore-copenhagen/artifacts/0f3tr0l7_2026-08-16%2023_45_31.721%2B0200.webp",
    area: "islands-brygge",
    big: true,
  },
  {
    name: "Sandkaj in Nordhavn",
    meta: "Nordhavn",
    desc: "Sleek harbourfront where locals sunbathe and dive straight off the quay, packed all summer.",
    image: "https://customer-assets-cm19k8pv.emergentagent.net/job_explore-copenhagen/artifacts/3q8wbu9f_2026-08-16%2023_58_49.212%2B0200.webp",
    area: "nordhavn",
    big: true,
  },
];

export const DAY_TRIPS = [
  {
    name: "Bakken & Dyrehaven",
    meta: "25 min by train · Klampenborg",
    desc: "The world's oldest amusement park sits inside a royal deer park — roam ancient oaks and spot wild deer, then ride the rollercoasters.",
    image: IMG("1733498669242-ab73bd57ccdf"),
    big: false,
  },
  {
    name: "Louisiana Museum",
    meta: "35 min by train · Humlebæk",
    desc: "World-class modern art in a sculpture park perched over the Øresund. Arguably the best day trip in Scandinavia.",
    image: IMG("1720784043091-5d9e73f63609"),
    big: true,
  },
  {
    name: "Malmö, Sweden",
    meta: "35 min over the bridge",
    desc: "Tick off a second country. Cross the iconic Øresund Bridge for a Swedish fika, the Turning Torso and a totally different vibe. Bring your passport.",
    image: IMG("1626819994289-85c4b724b903"),
    big: true,
  },
  {
    name: "Dragør",
    meta: "40 min by bus · Amager",
    desc: "A cobbled former fishing village of yellow cottages and hollyhocks. Fresh fish by the harbour, zero crowds.",
    image: IMG("1704887917222-89176c2a1571"),
    big: false,
  },
  {
    name: "Helsingør",
    meta: "45 min by train · North",
    desc: "Hamlet's Kronborg Castle guards the narrowest point to Sweden. Pair it with the brilliant Maritime Museum.",
    image: IMG("1748814670185-ae3f3b8fee7d"),
    big: false,
  },
];

export const EVENTS = [
  { month: "FEB", name: "Copenhagen Light Festival", note: "Three weeks of light art glowing across the dark winter city — free to wander." },
  { month: "MAY", name: "Copenhagen Marathon", note: "40,000 runners wind through every neighbourhood." },
  { month: "JUN", name: "Distortion", note: "Street parties take over parts of the city for days." },
  { month: "AUG", name: "Copenhagen Pride", note: "A huge, joyful parade and a week-long Pride Square party." },
  { month: "NOV–DEC", name: "Christmas Markets", note: "Glögg, christmas stalls and lights fill the city. Taste real Glögg.", to: "/christmas" },
];




// ---------------------------------------------------------------------------
// MASTER MAP DATA — aggregates every mentioned place across the whole site
// into a single, de-duplicated, colour-coded set for the interactive map.
// ---------------------------------------------------------------------------

export const MAP_CATEGORIES = {
  areas: { id: "areas", label: "Neighbourhoods", color: "#DF3226" },
  sights: { id: "sights", label: "Sights", color: "#0A0A0A" },
  food: { id: "food", label: "Food & Bakeries", color: "#E8590C" },
  swim: { id: "swim", label: "Swim spots", color: "#0077C8" },
  daytrips: { id: "daytrips", label: "Day trips", color: "#7C3AED" },
};

const FOOD_RE =
  /baker|bageri|bager|grill|reffen|torvehalle|broens|gadek|kødby|koedby|ismageri|banchina|coffee|smørrebr|smorrebr|gasoline|diamond|pizza|glace|caf[eé]|market|wine|hot ?dog|pølse|polse|burger|slice|street food|reffen/i;
const SWIM_RE =
  /havnebad|harbour bath|havnevig|\bbath\b|sandkaj|bølgen|boelgen|bolgen|\bswim\b|banchina|strand|beach|bellevue/i;

const norm = (s) => s.toLowerCase().replace(/[^a-z0-9]/g, "");

// The planner SPOTS hold the authoritative, user-corrected coordinates. Any
// pick, map-extra, sight or extra naming the same place resolves to these, so
// the small area maps and the big city map always show the pin in one spot.
const SPOT_COORD_BY_NAME = Object.fromEntries(SPOTS.map((s) => [norm(s.name), s.coords]));
export const canonicalCoords = (name, fallback) =>
  (name && SPOT_COORD_BY_NAME[norm(name)]) || fallback;

// A few places sit better under a different category than the keyword match implies.
const CATEGORY_OVERRIDE = {
  reffenstreetfood: "sights", // Reffen is a destination/hangout, not just food — show it as a sight
};

const categoryFor = (name) => {
  const override = CATEGORY_OVERRIDE[norm(name)];
  if (override) return override;
  if (SWIM_RE.test(name)) return "swim";
  if (FOOD_RE.test(name)) return "food";
  return "sights";
};

// Extra named spots that aren't held as area "picks" or planner spots.
const EXTRA_SWIM = [
  { name: "Fisketorvet Harbour Bath", coords: [55.6627, 12.564], tag: "Copencabana · pools by Fisketorvet" },
  { name: "Bellevue Beach", coords: [55.778, 12.592], tag: "Klampenborg · sandy beach & Arne Jacobsen towers" },
];

const EXTRA_FOOD = [
  { name: "Juno the Bakery", coords: [55.708, 12.578], tag: "Cardamom bun · Østerbro" },
  { name: "Hart Bageri", coords: [55.6772, 12.5416], tag: "Sourdough & buns · Frederiksberg" },
  { name: "Andersen Bakery", coords: [55.667138, 12.578329], tag: "Cakes & pastries · Islands Brygge" },
  { name: "Sankt Peders Bageri", coords: [55.6795, 12.5715], tag: "Giant Wednesday cinnamon bun · Indre By" },
  { name: "La Glace", coords: [55.6786, 12.5735], tag: "Layer cakes · Indre By" },
  { name: "Torvehallerne", coords: [55.6838, 12.5695], tag: "Food market · Indre By" },
  { name: "Gasoline Grill", coords: [55.6795, 12.579], tag: "Cult smash burgers · Indre By" },
  { name: "Lille Bakery", coords: [55.6915, 12.6065], tag: "Pastries & wine · Refshaleøen" },
];

// Build the master POI list (everything except neighbourhoods & day trips).
function buildPois() {
  const seen = new Set();
  const out = [];
  const coordKey = (c) => `${c[0].toFixed(4)},${c[1].toFixed(4)}`;
  const add = (p) => {
    if (!p.coords) return;
    const nKey = norm(p.name);
    const cKey = coordKey(p.coords);
    if (seen.has(nKey) || seen.has(cKey)) return; // skip same name OR same spot
    seen.add(nKey);
    seen.add(cKey);
    out.push({ name: p.name, coords: p.coords, tag: p.tag });
  };

  // 1. Every area "pick" (the spots named on each neighbourhood page)
  AREAS.forEach((a) =>
    (a.picks || []).forEach((p) => add({ name: p.name, coords: canonicalCoords(p.name, p.coords), tag: p.note }))
  );
  // 2. Every planner spot that lives in the city (skip out-of-town day trips)
  SPOTS.forEach((s) => {
    if (s.cluster !== "daytrip") add({ name: s.name, coords: s.coords, tag: CLUSTERS[s.cluster] });
  });
  // 3. Curated must-see sights
  SIGHTS.forEach((s) => add({ name: s.name, coords: canonicalCoords(s.name, s.coords) }));
  // 4. Named food + swim spots not already covered
  EXTRA_FOOD.forEach((p) => add({ ...p, coords: canonicalCoords(p.name, p.coords) }));
  EXTRA_SWIM.forEach((p) => add({ ...p, coords: canonicalCoords(p.name, p.coords) }));

  return out;
}

const POIS = buildPois();

// Neighbourhood pins (large, all in the single category colour)
const AREA_PLACES = AREAS.map((a) => ({
  name: a.name,
  coords: a.coords,
  color: MAP_CATEGORIES.areas.color,
  tag: a.tag,
  label: a.name,
  big: true,
  to: `/areas/${a.id}`,
  category: "areas",
}));

// Day-trip pins (far outside the city — coordinates come from the planner)
const DAYTRIP_PLACES = SPOTS.filter((s) => s.cluster === "daytrip").map((s) => ({
  name: s.name,
  coords: s.coords,
  color: MAP_CATEGORIES.daytrips.color,
  tag: "Day trip",
  category: "daytrips",
}));

// Categorised POI pins (sights / food / swim)
const POI_PLACES = POIS.map((p) => {
  const category = categoryFor(p.name);
  return { ...p, category, color: MAP_CATEGORIES[category].color };
});

// The single source of truth the map consumes.
export const MAP_PLACES = [...AREA_PLACES, ...POI_PLACES, ...DAYTRIP_PLACES];

export const placesByCategory = (catId) => MAP_PLACES.filter((p) => p.category === catId);
